module.exports = __webpack_public_path__ + "img/baroij.c755a947.jpg";